import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconChevronRight } from '@sorare/core/src/atoms/icons/system/iconChevronRight.ts';

const Root = styled(ButtonBase)`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: var(--unit);
  border: 1px solid var(--c-yellow-400);
  border-radius: 20px;
  background: var(--c-nl-500);
  backdrop-filter: blur(16px);
  color: var(--c-yellow-400);
  font: var(--t-brand-xxs);
  letter-spacing: -0.16px;
  text-transform: uppercase;
  white-space: nowrap;
`;

type Props = {
  onClick: () => void;
};
export const ActionRequiredCta = ({ onClick }: Props) => {
  return (
    <Root onClick={onClick}>
      <FormattedMessage defaultMessage="Action required" />
      <FontAwesomeIcon icon={iconChevronRight} />
    </Root>
  );
};
